module.exports = __webpack_public_path__ + "19d39915cf90fff274340476b7b11645.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/helm.png
// module id = 1002
// module chunks = 0